import { render, staticRenderFns } from "./franjas.vue?vue&type=template&id=20aea4d5&scoped=true&"
import script from "./franjas.vue?vue&type=script&lang=js&"
export * from "./franjas.vue?vue&type=script&lang=js&"
import style0 from "./franjas.vue?vue&type=style&index=0&id=20aea4d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aea4d5",
  null
  
)

export default component.exports